export enum TO_DO_STATUS {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED'
}

export enum SORT_MODE {
  SMART = 'SMART',
  CHRONOLOGICAL = 'CHRONOLOGICAL',
  DUE_DATE = 'DUE_DATE'
}

export enum TODO_TASK_INPUT_STATE {
  IDLE = 'idle',
  CONFIRM_OPEN = 'confirm_open',
  SUBMITTING = 'submitting'
}

export enum TODO_TASK_EXPANDED_SECTION {
  NONE = 'none',
  DUE_DATE = 'due_date',
  TOP = 'top',
  PROJECTS = 'projects',
  ASSIGNEE = 'assignee',
  COMMENTS = 'comments'
}

export enum FOCUS_SUMMARY_MODAL_MODE {
  CREATE = 'create',
  EDIT = 'edit'
}

export enum WebviewTodoTabId {
  TASKS = 'tasks',
  PROJECTS = 'projects'
}

/** TodoPlayer page gate: personal focus vs class checklist vs boot hold. */
export enum TODO_PLAYER_MODE {
  UNKNOWN = 'unknown',
  PERSONAL = 'personal',
  CLASS = 'class'
}
